export const resetPc = () => {
    const wH = window.innerHeight; // 当前窗口的高度
    const wW = window.innerWidth; // 当前窗口的宽度
    const def = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
    if (wW > 1400) {
        const rem = wW * def; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        const html = document.documentElement;
        html.style.fontSize = rem + "px"; //适用于PC网站
    } else {
        const rem = 1400 * def;
        const html = document.documentElement;
        html.style.fontSize = rem + "px";
    }
}



// WEBPACK FOOTER //
// ./src/utils/adapter.js